import React from 'react';
import ReactDOM from 'react-dom/client';
import "./sass/main.scss";
import './app.less';
import reportWebVitals from './reportWebVitals';
import { Background } from './Background';
import { Provider } from 'react-redux'
import { store } from './store/store';
import { BrowserRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter>
        <Background />
      </BrowserRouter>
    </Provider>


  </React.Fragment>
  // <React.StrictMode>
  //   <Playground />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
